if (typeof window.geotab === "undefined") {
    (function (window) {
        const isLetterOrDigitFn = () => {
            try {
                return (
                    reg => (sym: string) =>
                        sym.search(reg) === 0
                )(new RegExp("[\\p{L}\\d]", "u"));
            } catch (e) {
                // IE10-11 doesn't support this regex, we exclude all special symbols
                return (
                    reg => (sym: string) =>
                        sym.search(reg) === -1
                )(/[-\^<>\{\}\"/|;:.,~!?@#$%^=&*\]\\\(\)\[¿§«»ω⊙¤°℃℉€¥£№`'¢¡®©_+\s]/i);
            }
        };
        const forbiddenDatabases = ["unitTests", "geotab", "brands", "sdk", "apps", "addins", "drive"];
        const doubleZones = ["com", "org", "net", "edu", "ngo", "gob"];
        const host = location.host;
        const pathname = location.pathname || "/";
        const database = decodeURIComponent(pathname.split("/")[1]);
        const isLetterOrDigit = isLetterOrDigitFn();
        // it can be database name or path to the file (resetPassword.html for example)
        const isValidDatabase = db => !db.split("").some(c => !isLetterOrDigit(c) && c !== "_") && forbiddenDatabases.indexOf(db) < 0;
        const urlBaseRegExp = /\?.*$/;
        const newLineRegex = /%0d%0a/gi;
        const sanitizeCRLF = data => (data || "").replace(newLineRegex, "");
        const ajaxRequest = function (
            url: string,
            successCallback: (responseText: string, xhr: XMLHttpRequest) => void,
            errorCallback: (url: string, xhr: XMLHttpRequest) => void,
            method = "GET",
            contentType = "application/json"
        ) {
            let xhr = new XMLHttpRequest();
            let methodName = method.toUpperCase();
            let isGet = methodName === "GET";
            let urlBase = url.replace(urlBaseRegExp, "");
            let params = url.split("?")[1] || "";

            xhr.open(methodName, sanitizeCRLF(urlBase + (isGet && params ? "?" + params : "")), true);
            xhr.setRequestHeader("Content-Type", contentType);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status !== 200) {
                        errorCallback(url, xhr);
                        return;
                    }

                    successCallback(xhr.responseText, xhr);
                }
            };

            xhr.timeout = 30000;
            xhr.ontimeout = function () {
                errorCallback(url, xhr);
            };

            xhr.send(!isGet && params ? params : null);
            return xhr;
        };
        const getPrefix = function (parts) {
            let prefix = {
                prefix: "",
                prefixNumber: "",
                domain: "",
                subDomain: "",
                zone: ""
            };

            if (parts.length > 1) {
                let zone = parts.pop() || "";
                let domain = parts.pop() || "";

                // zone name consist of two parts .com.uk
                if (doubleZones.indexOf(domain) >= 0) {
                    zone = `${ domain }.${ zone }`;
                    domain = parts.pop() || "";
                }

                if (isNaN(+zone) && isNaN(+domain)) {
                    prefix.zone = zone;
                    prefix.domain = domain;

                    let urlPrefix = parts.shift() || "";
                    prefix.prefixNumber = (urlPrefix.match(/\d+$/i) || [""]).shift() || "";
                    prefix.prefix = urlPrefix.replace(prefix.prefixNumber, "");

                    prefix.subDomain = parts.length > 0 ? parts.join("") : "";
                }
            }

            return prefix;
        },
        dotPos = host.indexOf("."),
        columnPos = host.indexOf(":"),
        urlWithoutPrefix = columnPos !== -1 && (dotPos === -1 || dotPos > columnPos),
        vendorPrefix = getPrefix(urlWithoutPrefix ? [] : host.split("."));
        /**
         * Root namespace
         */
        const getGlobalObject = () => window;
        const geotabMainObj: Geotab = {
            //place for the future Add-Ins
            addin: {},
            /**
             * Performs AJAX request
             */
            load: ajaxRequest,
            declare: function (...rest: any[]) {
                let o: any = getGlobalObject();
                for (let i = 0; i < rest.length; i = i + 1) {
                    let parts = rest[i].split(".");

                    for (let j = 0; j < parts.length; j = j + 1) {
                        let part = parts[j];
                        if (!part) {
                            break;
                        }
                        o[part] = o[part] || {};
                        o = o[part];
                    }
                }
                return o;
            },
            location: {
                host,
                database: isValidDatabase(database) ? database : "",
                getVendorPrefix: () => vendorPrefix
            },
            getSharedVariable: (function () {
                const vars: { [key: string]: any } = {};

                return function (name: string) {
                    if (!vars[name]) {
                        vars[name] = {};
                    }
                    return vars[name];
                };
            })()
        };
        window.geotab = geotabMainObj;
    })(window);
}